(function() {
    angular
        .module('emarket.commons')
        .controller('CustomFieldContainerController', ['$log', '$scope', '$timeout', 'CustomFields', function($log,
            $scope,
            $timeout,
            CustomFields) {
            var vm = this;
            var scope = $scope;
            vm.selected = scope.ngModel;
            var transformFields = function() {
                var fields = {};
                if ($scope.fields) {
                    $scope.fields
                        .sort(function(a, b) {
                            return a.sort - b.sort;
                        })
                        .forEach(function(field) {
                            if (!fields[field.group]) {
                                fields[field.group] = [];
                            }
                            fields[field.group].push(field);
                        });
                    vm.fields = fields;
                }
            };
            vm.findDependency = function(event, field, selectedValue) {
                if (field.type !== 'dependentList') {
                    return;
                }
                CustomFields.getByParentValue(field._id, selectedValue).then(function(field) {
                    var index;
                    $scope.fields.some(function(_field, i) {
                        if (_field.dependAt === field.dependAt) {
                            index = i;
                            return true;
                        }
                    });
                    if (index) {
                        $scope.fields.splice(index, 1);
                    }
                    $scope.fields.push(field);
                    transformFields();
                });
            };
            var hiddenEvent = $scope.$watch(function() {
                return $scope.hiddenTabs;
            },
            function() {
                if ($scope.hiddenTabs) {
                    vm.selectedTab = -1;
                } else {
                    vm.selectedTab = 0;
                }
            });

            var showEvent = $scope.$watch(function() {
                return vm.selectedTab;
            },
            function() {
                if (vm.selectedTab >= 0) {
                    scope.hiddenTabs = false;
                    $timeout(function() {
                        vm.refresh = true;
                    }, 500);
                }
            });
            var fieldEvent = $scope.$watch(function() {
                return $scope.fields;
            },
            function() {
                transformFields();
            });

            var modelEvent = $scope.$watch(function() {
                return vm.selected;
            },
            function() {
                if (vm.selected) {
                    Object.keys(vm.selected).forEach(function(key) {
                        if (vm.selected[key] === null) {
                            delete vm.selected[key];
                        }
                    });
                }
            },
            true);

            $scope.$on('$destroy', function() {
                modelEvent();
                fieldEvent();
                hiddenEvent();
                showEvent();
            });
        }]);
}());
